<div class="avatar-box">
  {{ label }}
  <img
    *ngIf="!!data"
    [src]="data"
    alt=""
  />
</div>
